export default __webpack_public_path__ + "static/bed-bath-beyond-6-6-f5b6f4fe22b871af31451f25106a127c.webp";